import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FlexusActionPanelBase, CoreServices } from 'flx-engine';


@Component({
    selector: 'workflow-action-panel',
    template: `
        <h1>Action Panel baseeee</h1>
        <workflow-panel-node [activeActionPanel]="activeActionPanel"></workflow-panel-node>
        <!-- <router-outlet></router-outlet> -->
        <!-- <node-router [organisms]="organisms" [compInstances]="compInstances"></node-router> -->
    `
})
export class WorkflowActionPanelComponent extends FlexusActionPanelBase {
    constructor(svc: CoreServices, route: ActivatedRoute) {
        super(svc, route);
    }


}
